import { Outlet } from "react-router-dom";
import { Row, Col } from 'antd'

const AuthLayout = () => {
  return (
    <Row>
      <Col span={24}>
        <Outlet />
      </Col>
    </Row>
  );
};

export default AuthLayout;
